import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { TreeTableModule } from 'primeng/treetable';
import { DataTableModule } from 'primeng/datatable'; // Deprecated, to be removed when all instances are upgraded to Table
import { MsalModule, MsalGuard, MsalInterceptor } from '@azure/msal-angular';
import { SharedModule } from 'primeng/shared';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressBarModule } from 'primeng/progressbar';
import { MessagesModule } from 'primeng/messages';
import { PasswordModule } from 'primeng/password';
import { ChipsModule } from 'primeng/chips';
import { DropdownModule } from 'primeng/dropdown';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { TooltipModule } from 'primeng/tooltip';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { FieldsetModule } from 'primeng/fieldset';
import { CheckboxModule } from 'primeng/checkbox';
import { InputSwitchModule } from 'primeng/inputswitch';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { MarkdownModule } from 'angular2-markdown';
import { RouterModule, Routes } from '@angular/router';
import { DownloadsComponent } from './components/downloads/downloads.component';
import { ViewComponent } from './components/view/view.component';
import { FormsModule } from '@angular/forms';
import { CurrentUserService } from './services/current-user.service';
import { DownloadLogComponent } from './components/download-log/download-log.component';
import { IsAdmin } from './guards/isAdmin';
import { SignoutComponent } from './components/signout/signout.component';
import { FreshdeskComponent } from './components/freshdesk/freshdesk.component';
import { AppInsightsModule } from 'ng2-appinsights';
import { AdminConnectListComponent } from './components/admin-connect-list/admin-connect-list.component';
import { AdminConnectDetailComponent } from './components/admin-connect-detail/admin-connect-detail.component';
import { UserConnectComponent } from './components/userConnect/userConnect.component';
import { EvaluationSystemService } from './services/evaluation-system.service';
import { TrainingSessionsListComponent } from './components/training-sessions-list/training-sessions-list.component';
import { TrainingSessionDetailComponent } from './components/training-session-detail/training-session-detail.component';
import { TrainingUserDetailComponent } from './components/training-user-detail/training-user-detail.component';
import { TrainingSessionService, TrainingSessionUserService, TrainingCloudActivityService, FilesService, EvaluationService, RegionsService, QaSessionService } from './services/GI.Web.Services.g';
import { ValidationService } from './services/validation.service';
import { RdpService } from './services/rdp.service';
import { ResourceDeploymentStateToStringPipe } from './pipes/resourceDeploymentStatePipe';
import { LogLevel } from 'msal';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { RegionSelectionComponent } from './components/region-selection/region-selection.component';
import { QaSessionsListComponent } from './components/qa-sessions-list/qa-sessions-list.component';
import {AadAuthority} from "msal/lib-commonjs/AadAuthority";

//let AadAuthority:any;
(<any>AadAuthority).TrustedHostList = {
  "login.windows.net": "login.windows.net",
  "login.chinacloudapi.cn": "login.chinacloudapi.cn",
  "login.cloudgovapi.us": "login.cloudgovapi.us",
  "login.microsoftonline.com": "login.microsoftonline.com",
  "login.microsoftonline.de": "login.microsoftonline.de",
  "login.microsoftonline.us": "login.microsoftonline.us",
  "geoinsightsbtc.b2clogin.com": "geoinsightsbtc.b2clogin.com"
}

const appRoutes: Routes = [
  { path: 'downloads', component: DownloadsComponent, canActivate: [MsalGuard] },
  { path: 'downloadLog', component: DownloadLogComponent, canActivate: [MsalGuard] },
  { path: 'view/:file', component: ViewComponent, canActivate: [MsalGuard] },
  { path: 'signout', component: SignoutComponent },
  { path: 'adminconnectlist', component: AdminConnectListComponent, canActivate: [MsalGuard] },
  { path: 'evaluations', component: AdminConnectListComponent, canActivate: [MsalGuard] },
  { path: 'adminconnectdetail/:id', component: AdminConnectDetailComponent, canActivate: [MsalGuard] },
  { path: 'userconnect', component: UserConnectComponent, canActivate: [MsalGuard] },
  { path: 'trainingsessions', component: TrainingSessionsListComponent, canActivate: [MsalGuard] },
  { path: 'trainingsession/:id', component: TrainingSessionDetailComponent, canActivate: [MsalGuard] },
  { path: 'usertraining/:studentId', component: TrainingUserDetailComponent },
  { path: 'qa', component: QaSessionsListComponent, canActivate: [MsalGuard] },
  {
    path: '',
    component: FreshdeskComponent,
    pathMatch: 'full',
    canActivate: [MsalGuard]
  }
];

@NgModule({
  declarations: [
    AppComponent,
    DownloadsComponent,
    ViewComponent,
    SignoutComponent,
    FreshdeskComponent,
    DownloadLogComponent,
    AdminConnectListComponent,
    AdminConnectDetailComponent,
    UserConnectComponent,
    TrainingSessionsListComponent,
    TrainingSessionDetailComponent,
    TrainingUserDetailComponent,
    ResourceDeploymentStateToStringPipe,
    RegionSelectionComponent,
    QaSessionsListComponent,
  ],
  imports: [
    MarkdownModule.forRoot(),
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: false } // <-- debugging purposes only
    ),
    MsalModule.forRoot({
      clientID: '671488aa-7088-4591-9aba-698d56a10fc3',
      authority: 'https://geoinsightsbtc.b2clogin.com/tfp/geoinsightsbtc.onmicrosoft.com/b2c_1a_signup_signin',
      consentScopes: ['https://geoinsightsbtc.onmicrosoft.com/gidownload/demo.read', 'openid'],
      unprotectedResources: ['api/TrainingSessionUser/'],
      popUp: false,
      level: LogLevel.Verbose,
      piiLoggingEnabled: true,
      cacheLocation: 'localStorage',
      redirectUri: window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')//  "http://localhost:4200/"
    }),
    BrowserModule,
    SharedModule,
    TreeTableModule,
    TableModule,
    DataTableModule,
    ButtonModule,
    FormsModule,
    DialogModule,
    InputTextModule,
    CalendarModule,
    CardModule,
    MultiSelectModule,
    ProgressBarModule,
    MessagesModule,
    PasswordModule,
    ChipsModule,
    DropdownModule,
    ConfirmDialogModule,
    TooltipModule,
    ProgressSpinnerModule,
    FieldsetModule,
    CheckboxModule,
    InputSwitchModule,
    BrowserAnimationsModule,
    AppInsightsModule,
    HttpClientModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    CurrentUserService,
    FilesService,
    IsAdmin,
    EvaluationService,
    EvaluationSystemService,
    ConfirmationService,
    TrainingSessionService,
    TrainingSessionUserService,
    TrainingCloudActivityService,
    ValidationService,
    QaSessionService,
    RdpService,
    RegionsService,
    ResourceDeploymentStateToStringPipe  // In providers also since used like a service in component class in addition to template
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts